import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, editedAreaAction } from '../../reducers/actions';
import { AreaService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.EDIT_AREA),
    switchMap(action=>
      AreaService.update(action.area, store).pipe(
        map(data =>editedAreaAction(data)),
        catchError(retryAuthentication(action$, 'epics/areas/editArea'))
      )
    )
  );
}


// WEBPACK FOOTER //
// ./src/epics/areas/editArea.js